import { request } from '@/shared/api/request'

export const rejectMembers = (externalId, page, size, iin, isEmployee) => {
	return request({
		url: `colcontract/tradeUnion/person/reject/${externalId}?page=${page}&size=${size}&iin=${iin}&isEmployee=${isEmployee}`,
		method: 'POST',
	})
}
